// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toolbar-module__main--fa9SW {
    border-radius: 12px;
    padding: 8px;
    background: var(--color-general-white);
    box-shadow: 0px 3px 32px 0px #857a6d33;
    position: absolute;
    bottom: 48px;
    left: 50%;
    transform: translateX(-50%);
}
`, "",{"version":3,"sources":["webpack://./src/dom/Demo/Toolbar.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;IACZ,sCAAsC;IACtC,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;AAC/B","sourcesContent":[".main {\n    border-radius: 12px;\n    padding: 8px;\n    background: var(--color-general-white);\n    box-shadow: 0px 3px 32px 0px #857a6d33;\n    position: absolute;\n    bottom: 48px;\n    left: 50%;\n    transform: translateX(-50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Toolbar-module__main--fa9SW`
};
export default ___CSS_LOADER_EXPORT___;
